<template>
    <div class="page_container">
        <div class="add_btn_wrap">
          <el-input @keyup.enter.native="handleClickSearch" @clear="handleClickSearch" clearable placeholder="请输入公司名称" size="small" v-model="keyWord"  >
            <i class="el-icon-search el-input__icon"  slot="suffix"  @click="handleClickSearch">  </i>
          </el-input>
        </div>
        <el-table :data="tableData" :max-height="tableHeight" v-loading="loading">
          <el-table-column label="ID" prop="company_id" align="center" width="100"></el-table-column>
          <el-table-column label="公司名称" prop="name" show-overflow-tooltip min-width="200">
            <template slot-scope="{row}">
              <span class="theme_color" @click="handleClickDetail(row)">{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="租户起止时间" prop="version" show-overflow-tooltip width="160">
            <template slot-scope="{row}">
               <span  v-text="row.member_start_date == null ? '永久' : row.member_start_date + '-' +row.member_end_date"></span>
            </template>
          </el-table-column>
          <el-table-column label="企业认证" prop="version" show-overflow-tooltip width="140">
            <template slot-scope="{row}">
               <i class="authStatus" :class="'authStatus' + row.authStatus"></i><span v-text="row.authStatus == 1 ? '已认证' : row.authStatus == 2 ? '待审核' : row.authStatus == 3 ? '未认证' : '未认证'"></span>
            </template>
          </el-table-column>
          <el-table-column label="管理员人数" prop="roleUserCount" align="center" min-width="100">
            <template slot-scope="{row}">
              <span class="theme_color" @click="getRoleUserlist(row)">{{ row.roleUserCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司人数" prop="userCount" align="center" min-width="100">
            <template slot-scope="{row}">
              <span class="theme_color" @click="getUserList(row)">{{ row.userCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="小程序名称" prop="wxapp_name" show-overflow-tooltip min-width="160"></el-table-column>
          <el-table-column label="状态" prop="version" show-overflow-tooltip width="140">
            <template slot-scope="{row}">
              <i class="authStatus authStatus1" ></i><span>正常</span>
            </template>
          </el-table-column>
            <el-table-column align="center" label="操作" width="100" fixed="right">
                <template slot-scope="{row}">
                  <el-dropdown style="margin-left: 5px" placement="bottom" trigger="click">
                    <el-button type="text" icon="el-icon-more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="row.authStatus == 2" @click.native="handleClickExamine(row)">认证审核</el-dropdown-item>
                      <el-dropdown-item @click.native="handleClickEdit(row)">编辑</el-dropdown-item>
                      <el-dropdown-item @click.native="handleClickWxapp(row)">小程序管理</el-dropdown-item>
                      <el-dropdown-item @click.native="handleClickWxOfficial(row)">公众号管理</el-dropdown-item>
                      <el-dropdown-item @click.native="handleClickDel(row.company_id)">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pagination.pageNum"
                       :page-size="pagination.pageSize"
                       :page-sizes="pagination.pageSizes"
                       :total="pagination.total"
                       @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"
                       align="right"
                       background
                       layout="total, prev, pager,next,sizes">
        </el-pagination>

        <EditCompany v-if="editVisible"
                    :edit-visible.sync="editVisible"
                    :companyId="companyId"
                    @success="getTableData"/>
      <Personnel :personnelVisible.sync="personnelVisible"
                 :companyId="companyId"
                 :role_id="admin_role_id"
                 v-if="personnelVisible"/>
      <RolePersonnel :rolePersonnelVisible.sync="rolePersonnelVisible"
                     :companyId="companyId"
                     v-if="rolePersonnelVisible"/>
      <Wxapp :wxappVisible.sync="wxappVisible"
             :companyId="companyId"
             @success="getTableData"
             :storeWxappId="storeWxappId"
             v-if="wxappVisible"/>
      <WxOfficial :wxOfficialVisible.sync="wxOfficialVisible"
                  :companyId="companyId"
                  @success="getTableData"
                  v-if="wxOfficialVisible"
                  :officialAccountId="officialAccountId"/>
      <WxInvite :wxInviteVisible.sync="wxInviteVisible"
                :companyId="companyId"
                :companyUrl="companyUrl"
                @success="getTableData"
                v-if="wxInviteVisible"/>
      <Examine :examineVisible.sync="examineVisible"
                :companyId="companyId"
                @success="getTableData"
                v-if="examineVisible"/>
      <Detail :detailVisible.sync="detailVisible"
               :companyId="companyId"
               v-if="detailVisible"/>
    </div>
</template>
<script>
import {DelCompany, ReqCompanyList} from '@/api'
  import EditCompany from './editCompany'
  import Personnel from '../company/personnel'
  import RolePersonnel from '../company/rolePersonnel.vue'
  import Wxapp from '../company/wxApp.vue'
  import WxInvite from '../company/wxInvite.vue'
  import WxOfficial from '../company/wxOfficial.vue'
import Examine from './examine.vue'
import Detail from './detail.vue'

    export default {
        name: "tenant",
        data() {
            return {
              keyWord:'',
                isMobile: false,
                loading: false,
                tableData: [],
                pagination: {
                    total: 0,
                    pageSize: 15,
                    pageSizes: [15, 30, 50, 100],
                    pageNum: 1,
                },
                drawerSize: '35%',
                addDrawerShow: false,
                editDrawerShow: false,
                tableHeight: 600,
                resizeTimer: null,
                companyId: 0,
                admin_role_id: 0,
                editVisible: false,
                personnelVisible: false,
                rolePersonnelVisible: false,
                wxappVisible: false,
                storeWxappId: 0,
                wxInviteVisible: false,
                wxOfficialVisible: false,
                officialAccountId: 0,
                companyUrl: '',
                examineVisible:false,
                detailVisible:false,
            }
        },
        components: {
          EditCompany,
          Personnel,
          RolePersonnel,
          Wxapp,
          WxInvite,
          WxOfficial,
          Examine,
          Detail,
        },
        created() {
            this.getTableData()
            this.tableHeight = this.getTableHeight(275)
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    this.tableHeight = this.getTableHeight(275)
                    this.resizeTimer = null
                }, 100)
            }
        },
        mounted() {
        },
        methods: {
          // 查看详情
          handleClickDetail(row){
            this.companyId = row.company_id
            this.detailVisible = true
          },
          // 获取公司管理员人数详细列表
          getRoleUserlist(row) {
            this.companyId = row.company_id
            this.rolePersonnelVisible = true
          },
          // 获取公司人数详细列表
          getUserList(row) {
            this.companyId = row.company_id
            this.admin_role_id = row.admin_role_id
            this.personnelVisible = true
          },
            // 认证审核
            handleClickExamine(row){
              this.companyId = row.company_id
              this.examineVisible = true
            },
            // 编辑
            handleClickEdit(row){
              this.companyId = row.company_id
              this.editVisible = true
            },
            // 小程序管理
            handleClickWxapp(row) {
              this.companyId = row.company_id
              this.storeWxappId = row.store_wxapp_id
              this.wxappVisible = true
            },
            // 公众号管理
            handleClickWxOfficial(row) {
              this.companyId = row.company_id
              this.officialAccountId = row.official_account_id
              this.wxOfficialVisible = true
            },


            handleClickSearch(){
              this.pagination.pageNum = 1
              this.getTableData()
            },
            getTableHeight(height) {
                let tableHeight
                if (window.innerHeight - height <= 300) {
                    tableHeight = 300
                } else {
                    tableHeight = window.innerHeight - height
                }
                return tableHeight
            },
            getTableData(){
              this.loading = true
              ReqCompanyList({
                keyWord: this.keyWord,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
              }).then(res => {
                if (res.code === 200) {
                  const {
                    data,
                    total
                  } = res.data
                  this.tableData = data
                  this.pagination.total = total
                  this.storeWxappId = 0
                  this.companyId = 0

                }
                this.loading = false
              })
            },
            handleSizeChange(val) {
                this.pagination.pageNum = 1;
                this.pagination.pageSize = val;
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val;
                this.getTableData()
            },

            handleClickAddVersion() {
                this.addDrawerShow = true
            },

            handleClickEditVersion(row) {
                this.editDrawerShow = true
                this.companyId = row.company_id
            },

          handleClickDel(id) {
                this.$confirm('删除该租户后不可恢复，是否继续？', '确定删除吗？', {
                    iconClass: 'icon-a-fenzu31 iconfont',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: '删除',
                    customClass: 'title_icon_message_box'
                }).then(() => {
                    DelCompany({
                        company_id: id
                    }).then(res => {
                        this.$message.success('删除成功')
                        this.getTableData()
                    })
                }).catch(() => {

                })
            },
        },
    }
</script>
<style lang="scss" scoped>
  .add_btn_wrap {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    margin-bottom: 16px;
    padding: 0 0 12px 0;
      .el-input{
        width: 260px;
      }
      .el-input__suffix{
        line-height: 32px;
      }
  }

  .version_content_wrap{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .authStatus{
    width: 6px;
    height: 6px;
    opacity: 1;
    background: rgba(191, 191, 191, 1);
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
  }
  .authStatus1{
    background: rgba(82, 196, 27, 1);
  }
  .authStatus2{
    background: rgba(251, 173, 19, 1);
  }
  .authStatus3{
    background: #b21f2d;
  }
</style>
